import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { DropdownMenuWrapper } from './DropdownMenu.elements'

// Context
import { useDropdown } from '../DropdownContext'

function DropdownMenu(props) {
  // Destructure
  const { children, left, ...rest } = props

  // Context
  const { isOpen, direction } = useDropdown()
  return (
    <DropdownMenuWrapper direction={direction} isOpen={isOpen} end={left} {...rest}>
      {children}
    </DropdownMenuWrapper>
  )
}

// Default Props
DropdownMenu.defaultProps = {
  left: false,
  children: '',
}

// Proptypes Validation
DropdownMenu.propTypes = {
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
}

export default DropdownMenu
